import { PhotoDocProcessingStatus } from "~generated";

export const PENDING_POLL_INTERVAL_MS = 5000;
export const PENDING_POLL_WINDOW_MS = 5 * 60 * 1000;

type PolledPhoto = {
  processing_status: PhotoDocProcessingStatus;
  created_at: string;
};

export function pollWhilePending(
  photos: PolledPhoto[] | undefined,
  now = Date.now(),
): number | false {
  const freshlyPending = photos?.some(
    (photo) =>
      photo.processing_status === PhotoDocProcessingStatus.PENDING &&
      now - Date.parse(photo.created_at) < PENDING_POLL_WINDOW_MS,
  );
  return freshlyPending ? PENDING_POLL_INTERVAL_MS : false;
}
